export const environment = {
  production: true,
  apiUrl: 'https://api-neftegaz.testnir.ru',
  clientId: 2,
  clientSecret: 'MVvOtr4mINuBsar8F5tohRZdZb2gMjbP0UeErIL9',
  project: null,
  licence: 'URGJPG2N7IDC',
  defaultLocale: 'ru'
};
